import React from "react";
import { Flex } from "@chakra-ui/layout";

function RentalScenarioTableNumber({
    label,
    symbol,
  }: {
    label: string | number;
    symbol: string;
  }) {
    return (
      <Flex justifyContent="center">
        <Flex
          flex="1"
          maxWidth="125px"
          justifyContent="space-between"
          alignItems="center"
        >
          <span>{symbol}</span>
          <span>{label}</span>
        </Flex>
      </Flex>
    );
  }

  export default RentalScenarioTableNumber;